export default "__VITE_ASSET__7d7ab665__"